import React from "react";
import { Check, Info } from "lucide-react";
import { PALETA, Avatar } from "@/components/personas/Avatar";

export const colorLibre = (familyMembers, excluirId) => {
  const usados = new Set(familyMembers.filter((f) => f.id !== excluirId).map((f) => f.color));
  return (PALETA.find((c) => !usados.has(c.id)) || PALETA[0]).id;
};

export const ColorPersona = ({ value, onChange, nombre, familyMembers, personaId }) => {
  const repetida = familyMembers.find((f) => f.id !== personaId && f.color === value);
  const nombreColor = PALETA.find((c) => c.id === value)?.label;
  return (
    <fieldset className="mb-4" data-testid="family-color">
      <legend className="block text-sm font-semibold text-[#4A5550]">Color de la persona</legend>
      <p className="text-sm text-[#6E7A74] mb-3">Elige un color para reconocerla fácilmente en la app.</p>
      <div className="flex items-center gap-3 mb-4 bg-white border border-[#E5DFD5] rounded-2xl p-3" data-testid="family-color-preview">
        <Avatar persona={{ name: nombre || "?", color: value }} size="lg" />
        <div className="min-w-0">
          <p className="font-heading font-bold text-lg text-[#1C2421] truncate">{nombre || "Nombre de la persona"}</p>
          <p className="text-sm text-[#4A5550]">Color: {nombreColor}</p>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-3" role="radiogroup" aria-label="Color de la persona">
        {PALETA.map((c) => {
          const sel = c.id === value;
          return (
            <button key={c.id} type="button" role="radio" aria-checked={sel} aria-label={c.label} title={c.label} data-testid={`family-color-${c.id}`}
              onClick={() => onChange(c.id)}
              className={`relative w-14 h-14 mx-auto rounded-full flex items-center justify-center transition-transform active:scale-95 ${sel ? "ring-4 ring-offset-2 ring-[#1C2421]" : "ring-1 ring-black/10"}`}
              style={{ backgroundColor: c.hex }}>
              {sel && <Check size={28} strokeWidth={3} className="text-white" aria-hidden="true" />}
            </button>
          );
        })}
      </div>
      {repetida && (
        <p data-testid="family-color-repetido" className="mt-3 text-sm text-[#92400E] bg-[#FFFBEB] rounded-xl p-3 flex gap-2">
          <Info size={18} className="shrink-0" /> {repetida.name} ya usa este color. Puedes guardarlo igualmente o elegir otro para distinguirlas mejor.
        </p>
      )}
    </fieldset>
  );
};
